import styled from 'styled-components';

export const LazyLoadingWrapper = styled.div`
  position: absolute;
  left: 50%;
  display: flex;
  align-items: center;
  height: calc(100vh - 108px);
`;
